import React from 'react';
import { BdsChipTag, BdsGrid, BdsLoadingSpinner } from 'blip-ds/dist/blip-ds-react';
import { DocumentStatus } from '../../models/knowledgeBase/Document';

interface DocumentStatusCellProps {
  status: DocumentStatus;
  processingText: string;
  statusTexts: Record<DocumentStatus, string>;
  documentId: string;
}

const getStatusColor = (status: DocumentStatus): 'info' | 'success' | 'danger' | 'disabled' => {
  switch (status) {
    case DocumentStatus.PROCESSING:
      return 'info';
    case DocumentStatus.ACTIVE:
      return 'success';
    case DocumentStatus.FAILED:
      return 'danger';
    case DocumentStatus.INACTIVE:
    default:
      return 'disabled';
  }
};

const DocumentStatusCell: React.FC<DocumentStatusCellProps> = ({
  status,
  processingText,
  statusTexts,
  documentId,
}) => {
  return (
    <div key={`status-container-${documentId}`}>
      <BdsChipTag color={getStatusColor(status)}>
        {status === DocumentStatus.PROCESSING ? (
          <BdsGrid direction="row" alignItems="center" gap="1" style={{ display: 'inline-flex' }}>
            <BdsLoadingSpinner size="extra-small" />
            <span>{processingText}</span>
          </BdsGrid>
        ) : (
          statusTexts[status]
        )}
      </BdsChipTag>
    </div>
  );
};

export default DocumentStatusCell;
